import React, { Component } from "react";
import classnames from "classnames";
import { connect } from "react-redux";

import { getUserNameForAvatar } from "Utils";

import { addUserToTeam, removeUserFromTeam, setUserOrder } from "Actions";
import { TTP_API_URL } from "Config";

import _ from "i18n";

export class User extends Component {
  state = {
    display: this.props.display
  };

  displayUser = (id, e) => {
    const { addUserToTeam, removeUserFromTeam } = this.props;

    const order = e.currentTarget.nextSibling.value;

    this.setState({
      display: !this.state.display
    });
    !this.state.display
      ? addUserToTeam(id, parseInt(order, 10))
      : removeUserFromTeam(id);
  };

  changeOrder = (id, e) => {
    const { setUserOrder } = this.props;
    if (this.state.display) {
      setUserOrder(id, e.currentTarget.value);
    }
  };

  renderAvatar() {
    const {
      avatar,
      avatarUrl,
      //onSelected,
      id,
      firstName,
      lastName,
      //isSelected,
      countUsers,
      order
    } = this.props;

    const { display } = this.state;
    /*const checkDiv = (
      <div className="author-check">
        <i
          id={`check-${id}`}
          className={classnames("icon icon-check", isSelected && "active")}
        />
      </div>
    );*/
    let options = [];
    for (let i = 1; i <= countUsers; i++) {
      options.push(
        <option key={`option-${i}`} value={i}>
          {i}
        </option>
      );
    }

    if (avatarUrl || avatar) {
      return (
        <div
          id={`avatar-${id}`}
          className={classnames("author-avatar" /*, isSelected && "selected"*/)}
          //onClick={onSelected}
          style={{
            backgroundImage: `url(${
              avatarUrl ? avatarUrl : TTP_API_URL + "/" + avatar
            })`
          }}
        >
          {/*checkDiv*/}
          <div className="official-actions">
            <i
              className={`icon icon-eye ${display ? "display" : "not-display"}`}
              onClick={this.displayUser.bind(this, id)}
              id={id}
            />
            <select
              defaultValue={order}
              onChange={this.changeOrder.bind(this, id)}
              className={order >= 10 ? "two-number" : ""}
            >
              {options}
            </select>
          </div>
        </div>
      );
    }

    return (
      <div
        id={`avatar-${id}`}
        className={classnames(
          "author-avatar empty-avatar"
          //isSelected && "selected"
        )}
        //onClick={onSelected}
      >
        <span>{getUserNameForAvatar(firstName, lastName)}</span>
        {/*checkDiv*/}
        <div className="official-actions">
          <i
            className={`icon icon-eye ${display ? "display" : "not-display"}`}
            onClick={this.displayUser.bind(this, id)}
            id={id}
          />
          <select
            defaultValue={order}
            className={order >= 10 ? "two-number" : ""}
            onChange={this.changeOrder.bind(this, id)}
          >
            {options}
          </select>
        </div>
      </div>
    );
  }

  /*renderSignature() {
    const {
      firstName,
      lastName,
      role,
      blogRoleInOrganization,
      defaultSignature,
      header
    } = this.props;

    let defaultSignatureDiv = [];
    if (defaultSignature && defaultSignature.title) {
      defaultSignatureDiv.push(<h3 key="h3">{defaultSignature.title}</h3>);
    } else {
      defaultSignatureDiv.push(<h3 key="h3">{firstName + " " + lastName}</h3>);
    }
    if (blogRoleInOrganization && blogRoleInOrganization.length > 0) {
      defaultSignatureDiv.push(
        <h4 key="h4">
          <span>
            {_(blogRoleInOrganization[0].role)}
            {blogRoleInOrganization[0].role !== "CHIEF_EDITOR" && (
              <span className="mandated">
                ({blogRoleInOrganization[0].mandated === 0
                  ? _("Not Mandated")
                  : _("Mandated")})
              </span>
            )}
          </span>
        </h4>
      );
    } else if (role && role.id) {
      defaultSignatureDiv.push(<h4 key="h4">{_(role.type)}</h4>);
    }
    if (defaultSignature && defaultSignature.head) {
      defaultSignatureDiv.push(<h5 key="h5">{defaultSignature.head}</h5>);
    } else if (header) {
      defaultSignatureDiv.push(<h5 key="h5">{header}</h5>);
    }

    return defaultSignatureDiv;
  }*/

  render() {
    const { id, firstName, lastName, title } = this.props;
    return (
      <div className="author column small-12 medium-6 large-4">
        {this.renderAvatar()}
        <div className="author-header">
          <h3>{`${firstName} ${lastName}`}</h3>
        </div>
        <input
          className="user-slogan"
          type="text"
          name={`user-${id}`}
          placeholder={_("Title")}
          defaultValue={title ? title : null}
        />
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  addUserToTeam: (id, order) => dispatch(addUserToTeam(id, order)),
  removeUserFromTeam: id => dispatch(removeUserFromTeam(id)),
  setUserOrder: (id, order) => dispatch(setUserOrder(id, order))
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(User);



// WEBPACK FOOTER //
// ./src/components/Settings/User.js